import { isDefined } from "@clipboard-health/util-ts";
import { useEffect, useRef } from "react";

/**
 * Returns the latest defined value of a variable.
 * @param value - The value to track.
 * @returns The latest defined value of the variable or `undefined`
 *   if the value has never been defined.
 */
export function useLatestDefinedValue<T>(value: T | undefined): T | undefined {
  const previousValue = useRef(value);
  useEffect(() => {
    if (isDefined(value)) {
      previousValue.current = value;
    }
  }, [value]);
  return value ?? previousValue.current;
}
